export default "__VITE_ASSET__BfVgNoZv__"